import { Link } from "react-router-dom";
import type { Post } from "@/types/content";
import PostCard from "@/components/feature/PostCard";
import SectionHeading from "@/components/feature/SectionHeading";

export default function HotPosts({ items }: { items: Post[] }) {
  return (
    <section aria-labelledby="hot-title" className="w-full py-14 md:py-20">
      <div className="mx-auto w-full px-4 md:px-8">
        <SectionHeading
          eyebrow="讨论区精选"
          title="热门吃瓜现场"
          description="来自各校讨论区的真实长帖，包含事件经过、关键信息和后续更新，读一篇就够了解来龙去脉。"
          action={
            <Link
              to="/topics"
              className="inline-flex shrink-0 items-center gap-1.5 rounded-md border border-foreground-300 px-4 py-2.5 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-400 hover:text-primary-700 whitespace-nowrap"
            >
              更多帖子
              <span className="flex h-4 w-4 items-center justify-center">
                <i className="ri-arrow-right-line"></i>
              </span>
            </Link>
          }
        />
        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {items.map((post) => (
            <PostCard key={post.id} post={post} />
          ))}
        </div>
      </div>
    </section>
  );
}